<!-- Animated Background -->
<div class="bg-animation">
  <div class="glow-orb orb-1"></div>
  <div class="glow-orb orb-2"></div>
  <div class="glow-orb orb-3"></div>
</div>

<div class="premium-container">
  <div class="glass-card text-center">
    <!-- Header -->
    <span class="lock-badge" aria-hidden="true"><i class="pi pi-lock"></i></span>
    <h1 class="gradient-text">Trial Session Expired</h1>
    <p class="subtitle">
      Your trial period has concluded.
      Please choose how you would like to proceed with your workspace data.
    </p>

    <!-- Options -->
    <div class="options-grid">
      <!-- Option 1: Continue -->
      <button type="button" class="option-card" [disabled]="loading" (click)="onContinueTrial()">
        <div class="icon-wrapper">
          <i class="pi pi-database"></i>
        </div>
        <div class="option-title">Keep Existing Data</div>
        <p class="option-desc">Preserve all data and settings created during your trial. Ideal for upgrading your
          account.</p>
      </button>

      <!-- Option 2: Truncate -->
      <button type="button" class="option-card destructive" [disabled]="loading" (click)="onTruncateAndNew()">
        <div class="icon-wrapper">
          <i class="pi pi-refresh"></i>
        </div>
        <div class="option-title">Start Fresh</div>
        <p class="option-desc">Clear all trial data and start with a completely empty, fresh database instance.</p>
      </button>
    </div>

    <!-- Footer Note -->
    <div class="footer-text">
      <i class="pi pi-info-circle"></i> Our team will be notified immediately upon your selection.
    </div>

    <!-- Premium Loading Overlay -->
    <div class="loading-overlay" *ngIf="loading">
      <div class="spinner-wrapper">
        <div class="spinner-ring"></div>
        <div class="spinner-ring-inner"></div>
      </div>
      <div class="loading-text">Processing Request...</div>
    </div>
  </div>
</div>

<p-toast position="bottom-center"></p-toast>